// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"c3361709","640":"c9a88de0"}[chunkId] + ".chunk.js";
};